module.exports = __webpack_public_path__ + "static/media/swapContentbox3.baa506ba.png";